"use client"

import type React from "react"
import { memo } from "react"
import { Link } from "react-router-dom"
import type { NavItem } from "../../../types/header"

interface NavLinkProps {
  item: NavItem
  isMobile?: boolean
  onMobileClose?: () => void
}

const NavLink: React.FC<NavLinkProps> = memo(({ item, isMobile = false, onMobileClose }) => {
  const getClassName = () => {
    const baseClass = isMobile ? "mobile-nav-link" : "nav-link"
    const buttonClass = isMobile ? "mobile-button" : item.variant === "primary" ? "primary-button" : "secondary-button"

    return item.isButton ? buttonClass : baseClass
  }

  const handleClick = () => {
    if (item.onClick) {
      item.onClick()
    }
    if (isMobile && onMobileClose) {
      onMobileClose()
    }
  }

  if (item.onClick) {
    return (
      <button onClick={handleClick} className={getClassName()} type="button">
        {item.label}
      </button>
    )
  }

  if (item.href) {
    return (
      <Link to={item.href} className={getClassName()} onClick={isMobile ? onMobileClose : undefined}>
        {item.label}
      </Link>
    )
  }

  return null
})

NavLink.displayName = "NavLink"

export default NavLink
